import {EventEmitter, Injectable} from "@angular/core";
import {LocalForageService} from "ngx-localforage";
import {User} from "../data/user";
import {Title} from "@angular/platform-browser";

/**
 * App service
 */
@Injectable()
export class StateService {
    protected loaded: boolean = false;
    public base: string = 'http://admin.windelknaller.at/';
    public initial: boolean = false;
    protected version: number = 2;

    public homeScroll: number = 0;

    public eventEmitter: any = {};

    public state: any = {};

    constructor(private storage: LocalForageService, protected title: Title) {
        this.state = this.initialState();
        this.base = this.base.replace(/^http(s)?:/, window.location.protocol);
    }

    protected initialState(): any {
        return {
            defaultLang: 'de',
            appName: 'Windelknaller',
            apiUrl: 'https://www.windelknaller.at/api',
            language: '',
            user: null
        };
    }

    public isLoggedIn(): Promise<any> {
        return this.getState('user').then((user: User) => {
            if (!user) return false;
            return user.admin == true;
        })
    }

    public watchLoggedIn(): EventEmitter<any> {
        return this.watchState('user')
    }

    public getLanguage(): Promise<any> {
        return this.getState('language').then((lang) => {
            if (lang) return Promise.resolve(lang);

            return this.getState('defaultLang');
        })
    }

    public setLanguage(value: string): any {
        return this.setState('language', value);
    }

    public getSessionId(): Promise<any> {
        return this.getState('user').then(user => {
            if (user && user.hasOwnProperty('sessionid')) {
                return user.sessionid;
            }

            return null;
        })
    }

    public saveState() {
        this.state.version = this.version;
        try {
            return this.storage.setItem('state', JSON.stringify(this.state));
        } catch (e) {
            console.info('Error: ', e);
        }
    }

    public loadState(): Promise<any> {
        if (!this.loaded) {
            return this.storage.getItem('state').toPromise().then((state) => {
                if (state) {
                    this.state = JSON.parse(state);
                }

                if (this.state && this.state.version != this.version) {
                    this.storage.clear();
                    this.state = this.initialState();
                }

                this.loaded = true;
                return Promise.resolve(this.state);
            });
        } else {
            return Promise.resolve(this.state);
        }
    }

    public setState(prop: string, value: any) {
        this.state[prop] = value;

        if (prop == 'title') {
            this.title.setTitle('Windelknaller - ' + value);
        }

        this.saveState();
        if (this.eventEmitter.hasOwnProperty(prop + '_set')) {
            this.eventEmitter[prop + '_set'].next(this.state[prop]);
        }
        return this.state[prop];
    }

    public getState(prop?: any): Promise<any> {
        return this.loadState().then(state => {
            if (state)
                return state.hasOwnProperty(prop) ? state[prop] : null;
        })
    }

    public watchState(prop?: any): EventEmitter<any> {
        if (!this.eventEmitter.hasOwnProperty(prop + '_set')) {
            this.eventEmitter[prop + '_set'] = new EventEmitter();
        }
        return this.eventEmitter[prop + '_set'];
    }
}



// WEBPACK FOOTER //
// ./src/app/service/state.ts